// extracted by mini-css-extract-plugin
export default {"columnsContainer":"columnsContainer__3mx2f","cellSummary":"cellSummary__2rv_s","orderSummaryHeader":"orderSummaryHeader__3Y0jT","orderSummaryHeaderTitle":"orderSummaryHeaderTitle__2Um6N","orderSummaryHeaderSubtitle":"orderSummaryHeaderSubtitle__3Z1Yx","bookingsList":"bookingsList__26Bhz","cellBasket":"cellBasket__2rPIB","newOrderButton":"newOrderButton__2IyJZ"};
    if(module.hot) {
      // 1778491663498
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  